<template>
    <div class="main-nav" ref="mainNav">
        <div class="main-nav-container" ref="mainNavContainer">

          <div class="nav-items-container">
            <div class="nav-item about-us" @click="changeState">
              <div class="main">about</div>
              <div class="sub">us</div>
            </div>
            <router-link to="/OurProductPage" class="nav-item our-products">
              <div class="sub">our</div>
              <div class="main">products</div>
            </router-link>
            <div class="nav-item our-work" @click="changeState">
              <div class="sub">our</div>
              <div class="main">work</div>
            </div>
            <div class="nav-item contact-us" @click="changeState">
              <div class="main">contact</div>
              <div class="sub">us</div>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "MainNav",

        methods: {
            changeState() {
                this.$emit('stateChanged')
            },
            animate() {
                let cx = Math.ceil(document.documentElement.clientWidth / 2.0);
                let cy = Math.ceil(document.documentElement.clientHeight / 2.0);
                let dx = event.clientX - cx;
                let dy = event.clientY - cy;

                let tiltx = (dy / cy);
                let tilty = -(dx / cx);
                let radius = Math.sqrt(Math.pow(tiltx, 2) + Math.pow(tilty, 2));
                let degree = (radius * 2);

                this.$refs.mainNav.style.transform = 'rotate3d(' + tiltx + ', ' + tilty + ', 0, ' + degree + 'deg)';
                this.$refs.mainNavContainer.style.transform = 'rotate3d(' + tiltx + ', ' + tilty + ', 0, ' + degree + 'deg)';
            },

            startAnimation() {
                document.documentElement.addEventListener('mousemove', this.animate);
            },
            stopAnimation() {
                document.documentElement.removeEventListener('mousemove', this.animate);
            }
        },

        mounted() {
            setTimeout(this.startAnimation, 4000);
        },

        beforeDestroy() {
            this.stopAnimation();
        }
    }
</script>

<style lang="scss">
    @import "MainNav";
</style>
